//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
     components: {
    },
    data(){
        return {
            i:0,
            cid:0,
            type:0,
            orderType:1,
            list:[],
            where:[],
        }
    },
    mounted(){
        this.cid = Number(this.$route.params.cid);
        this.i = Number(this.$route.params.i);
        this.type = Number(this.$route.params.type);
        this.orderType = Number(this.$route.params.order_type);
        if(this.i > 0){
            this.$route.meta.title = '待送详情';
            document.title = this.$route.meta.title;
        }else{
             this.$route.meta.title = '待取详情';
            document.title = this.$route.meta.title;
        }
        this.getList();
    },
    methods: {
        copy(val){
            this.$func.copy(val,event);
        },
        getList(){
            this.$api.waitPickupInfo({cid:this.cid,i:this.i,type:this.type,order_type:this.orderType}).then((res)=>{
                if(res){
                 this.list = res.data;
                }
            })  
        },
    },
}



// WEBPACK FOOTER //
// ./src/pages/waitPickupInfo.vue